export default __webpack_public_path__ + "static/media/img03.17a93e8a.jpg";